import React from 'react';
import dog from '../../../../assets/images/games/m-game/percy/dog.webp';
import ipod from '../../../../assets/images/games/m-game/percy/ipod.webp';
import rainbow from '../../../../assets/images/games/m-game/percy/rainbow.webp';
import shoe from '../../../../assets/images/games/m-game/percy/shoe.webp';
import world from '../../../../assets/images/games/m-game/percy/globe.webp';

export default function MKalypsoCipher() {
    return (
        <React.Fragment>
            <div className="m-kalypso">
                <div className="m-kalypso-row">
                    <img src={shoe} alt="shoe" /> - TA + H
                </div>
                <div className="m-kalypso-row">
                    <img src={ipod} alt="ipod" /> - i + <img src={world} alt="world" /> + IA
                </div>
                <div className="m-kalypso-row">
                    <img src={rainbow} alt="rainbow" /> - DU + <img src={dog} alt="dog" /> P/D
                </div>
            </div>
        </React.Fragment>
    );
}
